import { render, staticRenderFns } from "./view.vue?vue&type=template&id=d202e95e&scoped=true&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"
import style0 from "./view.vue?vue&type=style&index=0&id=d202e95e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d202e95e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d202e95e')) {
      api.createRecord('d202e95e', component.options)
    } else {
      api.reload('d202e95e', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=d202e95e&scoped=true&", function () {
      api.rerender('d202e95e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/view/view.vue"
export default component.exports